// components
import { getDirectionURL, MapElement } from "components/Map";

// icons
// import { SvgLocation } from "assets/icons/js/SvgLocation.js";
// import { SvgRightArrow } from "assets/icons/js/SvgRightArrow";

// styles
import "./styles.scss";
import { useTheme } from "components/ListingNew/ListingTheme";

export const ListingLocation = ({ metaData }: any) => {
	const lat = metaData?.latitude || 0;
	const long = metaData?.longitude || 0;

	const theme = useTheme();

	return (
		<div className="listingLocation__container">
			<MapElement latitude={lat} longitude={long} />
			{/* <p className="listingLocation__para">
				Note: Exact location will only be provided after booking the villa
			</p> */}

			<a
				className="listing__button__new__all"
				href={getDirectionURL(lat, long)}
				target="_blank"
				rel="noreferrer"
				aria-label="Get directions to the location"
				title="Get directions to the location"
				style={{
					marginTop: "20px",
					...theme?.borderBtn,
				}}
			>
				Get Directions
			</a>
		</div>
	);
};
